export default class TradeLineItem {
        constructor(data = {}) {
          this.id = data.id || null;
          this.invoiceId = data.invoiceId || null;
          this.name = data.name || null;
          this.unitCode = data.unitCode?.toUpperCase() || null;
          this.sellerAssignedID = data.sellerAssignedID || null;
          this.globalID = data.globalID || null;
          this.grossPrice = data.grossPrice || 0;
          this.netUnitPrice = data.netUnitPrice || 0;
          this.billedQuantity = data.billedQuantity || 0;
          this.categoryCode = data.categoryCode || null;
          this.taxPercent = data.taxPercent !== undefined ? data.taxPercent : null;
        }

        get netPrice() {
          return (this.netUnitPrice || 0) * (this.billedQuantity || 0);
        }



        toJSON() {
          return {
            id: this.id,
            invoiceId: this.invoiceId,
            name: this.name,
            unitCode: this.unitCode,
            sellerAssignedID: this.sellerAssignedID,
            globalID: this.globalID,
            grossPrice: this.grossPrice,
            netUnitPrice: this.netUnitPrice,
            billedQuantity: this.billedQuantity,
            categoryCode: this.categoryCode,
            taxPercent: this.taxPercent,
            netPrice: this.netPrice
          };
        }
      }